<template>
  <el-dialog
    v-if="dialogVisible"
    title="变更详情"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="cancelHandler"
  >
    <div class="container">
      <el-collapse v-model="activeNames" class="collapse-main-content">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              基本信息
            </div>
          </template>
          <div class="collapse-content">
            <BaseInfoForm
              :contractStatus="contractStatus"
              ref="baseInfoFormRef"
              :fetchData="formData"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              合同信息
            </div>
          </template>
          <div class="collapse-content">
            <el-collapse v-model="activeContractNames" class="collapse-main-content">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="collapse-title-pre">
                    <span></span>
                    空间行信息
                  </div>
                </template>
                <div class="collapse-content">
                  <SpaceRowTable
                    :contractStatus="contractStatus"
                    ref="storageLinesRef"
                    :fetchTableData="spacesList"
                  />
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  <div class="collapse-title-pre">
                    <span></span>
                    其他费用行信息
                  </div>
                </template>
                <div class="collapse-content">
                  <ExpenseRowTable
                    :contractStatus="contractStatus"
                    ref="settlementLinesRef"
                    :fetchTableData="expensesList"
                  />
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              附件上传
            </div>
          </template>
          <div class="collapse-content">
            <FileTable
              ref="fileTableRef"
              :attachments="attachments"
              :isShowDownBtn="isShowDownBtn"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelHandler" type="primary">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import BaseInfoForm from './../../../BaseInfoForm/index.vue';
  import SpaceRowTable from './../../../SpaceRowTable/index.vue';
  import ExpenseRowTable from './../../../ExpenseRowTable/index.vue';
  import { formatDate } from '@/utils/date';
  export default {
    name: 'VersionHistoryDialog',
    data() {
      return {
        dialogVisible: false,
        activeNames: ['1', '2', '3'],
        activeContractNames: ['1', '2'],
        formData: {},
        attachments: [],
        spacesList: [],
        expensesList: [],
        isShowDownBtn: true,
        contractStatus: '-1',
      };
    },
    methods: {
      cancelHandler() {
        this.dialogVisible = false;
      },
      openDialog(detail = {}) {
        console.log(detail);
        try {
          const { attachments, spacesList, expensesList, ...formData } = JSON.parse(detail);
          this.formData = {
            ...formData,
            leaseDateFrom: formatDate(formData.leaseDateFrom),
            leaseDateUnit: formatDate(formData.leaseDateUnit),
          };
          this.attachments = attachments;
          this.spacesList = spacesList;
          this.expensesList = expensesList;
          this.dialogVisible = true;
        } catch (e) {
          console.error(e);
          this.$message.error('获取数据错误');
        }
      },
    },
    components: {
      BaseInfoForm,
      SpaceRowTable,
      ExpenseRowTable,
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep .container {
    max-height: 400px;
    overflow-y: auto;
  }
</style>
